// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getDictionary } from '@synisys/dictionary'; // !important: this import is required for the snippet to work
import { directive, Directive } from 'lit/directive.js';
import { noop } from 'lodash-es';
export class TranslateMsg extends Directive {
    constructor(_partInfo) {
        super(_partInfo);
        this.languageChangeListener = noop;
        this.listening = false;
    }
    update(part, props) {
        this.key = props[0];
        this.registerListener(part);
        return this.render(this.key);
    }
    render(key) {
        return getDictionary().translate(key);
    }
    disconnected() {
        this.unregisterListener();
    }
    reconnected() {
        this.languageChangeListener();
        this.registerListener();
    }
    resolveListener(part) {
        if ((part === null || part === void 0 ? void 0 : part.type) === 2) {
            // ChildPart
            return () => { var _a, _b; return (_b = (_a = part.options) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.requestUpdate(); };
        }
        else {
            return () => this.render(this.key);
        }
    }
    registerListener(part) {
        if (!this.listening) {
            this.languageChangeListener = this.resolveListener(part);
            getDictionary().addListener('languageChanged', this.languageChangeListener);
            this.listening = true;
        }
    }
    unregisterListener() {
        getDictionary().removeListener('languageChanged', this.languageChangeListener);
        this.listening = false;
        this.languageChangeListener = noop;
    }
}
export const translate = directive(TranslateMsg);
